import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { values } from "~/assets/js/theme/constants";

const Mask = styled.div`
    height: ${(props) => props.size}px;
    width: ${(props) => props.size}px;
    -webkit-mask: url(${(props) => props.icon}) no-repeat center;
    mask: url(${(props) => props.icon}) no-repeat center;
    background-color: ${(props) => props.color};
    mask-size: ${(props) => props.maskSize};
    -webkit-mask-size: ${(props) => props.maskSize};
    transition: ${values.DEFAULT_TRANSITION_DURATION};
`;

const SvgMask = (props) => <Mask {...props} />;

SvgMask.defaultProps = {
    maskSize: "100%",
};

SvgMask.propTypes = {
    size: PropTypes.number,
    icon: PropTypes.string,
    color: PropTypes.string,
    maskSize: PropTypes.string,
};

export default SvgMask;
